export default __webpack_public_path__ + "static/media/EkoDiesel30_70.62bb71a7.svg";